import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-service-detail-modal',
  templateUrl: './service-detail-modal.component.html',
  styleUrls: ['./service-detail-modal.component.css']
})
export class ServiceDetailModalComponent implements OnInit {

  @Input() serviceDetail: any;
  @Output() closeModal = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
